import * as React from 'react'
import { PrismicPreviewProvider } from 'gatsby-plugin-prismic-previews'
import config from './config/site'

const linkResolver = (doc) => {
  if (doc.type === 'home') return '/'
  if (doc.type === 'about') return '/about'
  if (doc.type === 'contact') return '/contact'
  if (doc.type === 'case_studies_index') return '/case-studies'
  if (doc.type === 'case_studies_article') return `/case-studies/${doc.uid}`
  if (doc.type === 'services') return `/${doc.uid}`
  if (doc.type === 'services_items') {
    if (doc.data && doc.data.category && doc.data.category.uid) {
      return `/${doc.data.category.uid}/${doc.uid}`
    }
    return `/${doc.uid}`
  }
  return `/${doc.uid}`
}

const repositoryConfigs = [
  {
    repositoryName: config.prismic.repository,
    linkResolver,
    componentResolver: {
      home: React.lazy(() => import('./src/pages/index.js')),
      about: React.lazy(() => import('./src/pages/about.js')),
      contact: React.lazy(() => import('./src/pages/contact.js')),
      case_studies_index: React.lazy(() => import('./src/pages/case-studies.js')),
      case_studies_article: React.lazy(() => import('./src/templates/case-study.js')),
      services: React.lazy(() => import('./src/templates/service.js')),
      services_items: React.lazy(() => import('./src/templates/services-item.js')),
    },
  },
]

export const wrapRootElement = ({ element }) => (
  <PrismicPreviewProvider repositoryConfigs={repositoryConfigs}>
    {element}
  </PrismicPreviewProvider>
)
